import React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { TPAComponentsProvider } from './TPAComponentsConfig';
import { act } from 'react-dom/test-utils';
import { tpaComponentConfigDriver } from './TPAComponentsConfig.driver';

describe('TPAComponentsConfig', () => {
  describe('isExtendedPaletteEnabled', () => {
    it('should override extended palette to narrow pallete by default', async () => {
      const createDriver = createRendererWithUniDriver(
        tpaComponentConfigDriver,
      );
      const { driver } = createDriver(
        <TPAComponentsProvider value={{}}>Test</TPAComponentsProvider>,
      );

      await act(async () => {});

      expect(await driver.isPaletteOverriden()).toBe(true);
    });

    it('should not override extended palette when it is enabled', async () => {
      const createDriver = createRendererWithUniDriver(
        tpaComponentConfigDriver,
      );
      const { driver } = createDriver(
        <TPAComponentsProvider value={{ isExtendedPaletteEnabled: true }}>
          Test
        </TPAComponentsProvider>,
      );

      await act(async () => {});

      expect(await driver.isPaletteOverriden()).toBe(false);
    });

    it('should not override extended palette when deeply nested provider has it enabled', async () => {
      const createDriver = createRendererWithUniDriver(
        tpaComponentConfigDriver,
      );
      const { driver } = createDriver(
        <TPAComponentsProvider value={{}} dataHook="parent">
          <TPAComponentsProvider
            value={{ isExtendedPaletteEnabled: true }}
            dataHook="child"
          >
            Test
          </TPAComponentsProvider>
        </TPAComponentsProvider>,
      );

      await act(async () => {});

      expect(await driver.isPaletteOverriden()).toBe(false);
    });

    it('should enable extended palette after click', async () => {
      const createDriver = createRendererWithUniDriver(
        tpaComponentConfigDriver,
      );
      const EnableAfterClick = () => {
        const [isExtendedPaletteEnabled, setIsExtendedPaletteEnabled] =
          React.useState(false);

        const onClick = () => {
          setIsExtendedPaletteEnabled(true);
        };

        return (
          <TPAComponentsProvider
            value={{ isExtendedPaletteEnabled }}
            dataHook="parent"
          >
            <button onClick={onClick}>Enable extended palette</button>
          </TPAComponentsProvider>
        );
      };
      const { driver } = createDriver(<EnableAfterClick />);

      const button = await driver.getChildren('button');
      await button.click();

      expect(await driver.isPaletteOverriden()).toBe(false);
    });
  });
});
